import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

interface SupplementOverrideControls {
  type: AbstractControl<string>;
  overrideOkSupplement: AbstractControl<boolean>;
  overrideOrganizationSupplement: AbstractControl<boolean>;
}

export function supplementOverrideValidator(supplementOverrideType: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const form = control as FormGroup<SupplementOverrideControls>;

    if (form.controls.type.value !== supplementOverrideType) {
      return null;
    }

    return form.controls.overrideOkSupplement.value || form.controls.overrideOrganizationSupplement.value
      ? null
      : { supplementOverrideRequired: true };
  };
}
